// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__1NZfD","isEnd":"isEnd__2-KcL","plain":"plain__pVuHc","tight":"tight__2rIhS","snugPadding":"snugPadding__Vwf1K","trim":"trim__2gqg5","topTight":"topTight__KL0fy"};


//////////////////
// WEBPACK FOOTER
// ./components/LineWrapper/style.css
// module id = Zu9o
// module chunks = 0